import {
  LOADER,
  POST_LOGIN,
  CLIENTSDATA,
  SINGLECLIENT,
  SUBLOADER,
  LOGOUTLOADER,
  EMPLOYEESDATA,
  SINGLEEMPLOYEE,
  ADDASSET,
  ROLEDROPDOWN,
  ROLESDATA,
  ROLEIDDATA,
  LEADDATA,
  LEADIDDATA,
  SUPPORTDATA,
  SUPPORTIDDATA,
  TASKSDATA,
  TASKSDATAEMP,
  LEADEMP,
  ASSETEMP,
  TRAVELEMP,
  ACTIVETAB,
  INVOICE,
  STATS,
  PIPELINEOVERVIEW,
  TOPSALE,
  ASSETSSTATS,
  EMPTY,
  SALE,
  BILL,
  SINGLEADMIN,
  SINGLEASSET,
  SINGLEASSETS,
  REVENUE,
  SALEGROWTH,
  ASSETSSTATSMANGEMENT,
  NOTIFICATIONCOUNT,
  NOTIFICATION,
  UPDATE_LOGIN_DATA,
  UPDATE_LOGIN_DATA_TOKEN,
  POPUP,
  EMPSTATS,
  QUATERLYSALES,
  TOPCLIENT,
  ACTIVITYBYID,
  RECENTACTIVITY
} from "../Actions/actions";

const initialState = {
  loginData: {},
  role: "",
  clientsData: [],
  singleClient: {},
  singleAdmin: {},
  loader: false,
  subLoader: false,
  logoutLoader: false,
  employeesData: [],
  singleEmployee: {},
  assetData: [],
  roledropdown: [],
  rolesData: [],
  roleIdData: {},
  leadsData: [],
  leadIdData: {},
  supportData: [],
  supportIdData: {},
  taskData: [],
  taskemp: [],
  assetemp: [],
  leademp: [],
  travelemp: [],
  activeTab: '',
  invoice: [],
  stats: {},
  pipelineoverview: {},
  topsale: {},
  assetstats: {},
  assetstatsmangement: {},
  sale: {},
  bill: [],
  singleAsset: {},
  singleAssets: {},
  revenue: [],
  saleGrowth: [],
  notificationCount: {},
  notification: [],
  Privilages: [],
  popup: false,
  empstats: {},
  quarterlysales: {},
  topClient: [],
  activityById: [],
  recentActivites: []

};

function userReducer(state = initialState, action) {
  switch (action.type) {
    case POST_LOGIN:
      return {
        ...state,
        loginData: action.payload,
        role: action.role,
        Privilages: action?.Privilages
      };
    case UPDATE_LOGIN_DATA:
      return {
        ...state,
        loginData: { ...state.loginData, employeeData: action.payload },
      };
    case UPDATE_LOGIN_DATA_TOKEN:
      return {
        ...state,
        loginData: { ...state.loginData, ...action?.payload },
      };
    case EMPTY:
      return {
        loginData: {},
        role: "",
        clientsData: [],
        singleClient: {},
        loader: false,
        subLoader: false,
        logoutLoader: false,
        employeesData: [],
        singleEmployee: {},
        assetData: [],
        roledropdown: [],
        rolesData: [],
        roleIdData: {},
        leadsData: [],
        leadIdData: {},
        supportData: [],
        supportIdData: {},
        taskData: [],
        taskemp: [],
        assetemp: [],
        leademp: [],
        travelemp: [],
        activeTab: '',
        invoice: [],
        stats: {},
        empstats: {},
        pipelineoverview: {},
        topsale: {},
        assetstats: {},
        bill: [],
        singleAsset: {},
        singleAssets: {},
        revenue: [],
        assetstatsmangement: {},
        saleGrowth: [],
        notificationCount: {},
        notification: [],
        Privilages: [],
        popup: false,
        quarterlysales: {},
        topClient: [],
        activityById:[],
        recentActivites: []
      };
    case CLIENTSDATA:
      return {
        ...state,
        clientsData: action.payload,
      };
    case EMPLOYEESDATA:
      return {
        ...state,
        employeesData: action.payload,
      };
    case SINGLECLIENT:
      return {
        ...state,
        singleClient: action.payload,
      };
    case SINGLEADMIN:
      return {
        ...state,
        singleAdmin: action.payload,
      };
    case LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SUBLOADER:
      return {
        ...state,
        subLoader: action.payload,
      };
    case LOGOUTLOADER:
      return {
        ...state,
        logoutLoader: action.payload,
      };
    case SINGLEEMPLOYEE:
      return {
        ...state,
        singleEmployee: action.payload,
      };
    case ADDASSET:
      return {
        ...state,
        assetData: action.payload,
      };
    case QUATERLYSALES:
      return {
        ...state,
        quarterlysales: action.payload,
      };
    case TOPCLIENT:
      return {
        ...state,
        topClient: action.payload,
      };
    case ACTIVITYBYID:
      return {
        ...state,
        activityById: action.payload,
      };
    case ROLEDROPDOWN:
      return {
        ...state,
        roledropdown: action.payload,
      };
    case ROLESDATA:
      return {
        ...state,
        rolesData: action.payload,
      };
    case ROLEIDDATA:
      return {
        ...state,
        roleIdData: action.payload,
      };

    case LEADDATA:
      return {
        ...state,
        leadsData: action.payload,
      };
    case LEADIDDATA:
      return {
        ...state,
        leadIdData: action.payload,
      };
    case SUPPORTDATA:
      return {
        ...state,
        supportData: action.payload,
      };

    case SUPPORTIDDATA:
      return {
        ...state,
        supportIdData: action.payload,
      };
    case TASKSDATA:
      return {
        ...state,
        taskData: action.payload,
      };
    case TASKSDATAEMP:
      return {
        ...state,
        taskemp: action.payload,
      };
    case ASSETEMP:
      return {
        ...state,
        assetemp: action.payload,
      };
    case LEADEMP:
      return {
        ...state,
        leademp: action.payload,
      };
    case TRAVELEMP:
      return {
        ...state,
        travelemp: action.payload,
      };
    case ACTIVETAB:
      return {
        ...state,
        activeTab: action.payload,
      };
    case INVOICE:
      return {
        ...state,
        invoice: action.payload,
      };
    case STATS:
      return {
        ...state,
        stats: action.payload,
      };
    case EMPSTATS:
      return {
        ...state,
        empstats: action.payload,
      };
    case PIPELINEOVERVIEW:
      return {
        ...state,
        pipelineoverview: action.payload,
      };
    case TOPSALE:
      return {
        ...state,
        topsale: action.payload,
      };
    case SALE:
      return {
        ...state,
        sale: action.payload,
      };
    case BILL:
      return {
        ...state,
        bill: action.payload,
      };
    case ASSETSSTATS:
      return {
        ...state,
        assetstats: action.payload,
      };
    case ASSETSSTATSMANGEMENT:
      return {
        ...state,
        assetstatsmangement: action.payload,
      };
    case SINGLEASSET:
      return {
        ...state,
        singleAsset: action.payload,
      };
    case SINGLEASSETS:
      return {
        ...state,
        singleAssets: action.payload,
      };
    case REVENUE:
      return {
        ...state,
        revenue: action.payload,
      };
    case POPUP:
      return {
        ...state,
        popup: action.payload,
      };
    case SALEGROWTH:
      return {
        ...state,
        saleGrowth: action.payload,
      };
    case NOTIFICATIONCOUNT:
      return {
        ...state,
        notificationCount: action.payload,
      };
    case NOTIFICATION:
      return {
        ...state,
        notification: action.payload,
      };
    case RECENTACTIVITY:
      return {
        ...state,
        recentActivites: action.payload,
      };
    default:
      return state;
  }
}
export function subscriptionsCondition(login, func1, func2, func3) {
  // if (login == 'Free Forever') {
  //   func1()
  // }
  // else if (login == 'Repotal Pro') {
  //   func2()
  // }
  // else if (login == 'Repotal Ultimate') {
  func3()
  // }
}
export default userReducer;
export const subscriptionColors = {
  'Free Forever': "bg-gradient-to-b from-[#B3FFE7] to-[#EDEDED] text-black",
  'Repotal Pro': "bg-gradient-to-b from-[#B3EBFF] to-[#EDEDED] text-black",
  'Repotal Ultimate': "bg-gradient-to-b from-[#FFB3B3] to-[#EDEDED] text-black",
}